import { render } from "./collapse.vue?vue&type=template&id=27bc84df&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=27bc84df&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27bc84df"

export default script